










import Vue, { PropType } from 'vue'

import { Message, MessageChannel } from 'base/store/state.interface'

import ChannelMembersView from './channel/members/ChannelMembersView.vue'
import { ChatService } from './chat/ChatService'
import ChatView, { ChatAction } from './chat/ChatView.vue'

export default Vue.extend({
  components: {
    ChannelMembersView,
    ChatView
  },
  props: {
    channel: {
      type: Object as PropType<MessageChannel | undefined>,
    },
    isPrimary: {
      type: Boolean as PropType<Boolean>,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      viewStack: ['chat'],
      prevChannel: undefined as MessageChannel | undefined
    }
  },
  computed: {
    presentedView(): string {
      if (this.viewStack.length === 0) return 'chat'

      return this.viewStack[this.viewStack.length - 1]
    },
    messages(): Message[] {
      if (!this.channel) {
        return []
      }
      return ChatService.getChannelMessages(this.channel)
    }
  },
  methods: {
    async chatViewActionSelected(action: ChatAction): Promise<void> {
      switch (action) {
      case ChatAction.showMembers:
        this.viewStack.push('members')
        break
      case ChatAction.removeChannelFromLayout:
        void this.$store.dispatch('setRemoveChannelFromCollection', this.channel)
        break
      }
    },
    pop(): void {
      if (this.viewStack.length > 0) {
        this.viewStack.pop()
      }
    },
    subscribe() {
      const channel = this.channel

      if (!channel) {
        return
      }

      const channelId = channel.id
      const channelOpenInAnotherComponent = ChatService.isChannelOpened(channelId)

      ChatService.addOpenedChannel(channel)

      if (!channelOpenInAnotherComponent) {
        // tslint:disable-next-line: no-floating-promises
        this.$store.dispatch('markChannelAsRead', channelId)
      }
    },
    unsubscribe() {
      const channel = this.channel

      if (!channel) {
        return
      }

      ChatService.removeOpenedChannel(channel)
    }
  },
  watch: {
    channel() {
      const channel = this.channel

      if (channel === this.prevChannel) {
        return
      }

      this.prevChannel = channel

      if (channel) {
        this.subscribe()
        return
      }

      this.unsubscribe()
    }
  },
  mounted() {
    this.subscribe()
  },
  destroyed() {
    this.unsubscribe()
  }
})
